module.exports = __webpack_public_path__ + "static/media/Aspen2.a4d32595.jpg";